import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AddItemToTable } from '../models/pos.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersServiceAdapter {
  constructor(private _httpClient: HttpClient) {}

  public addOrderItemToOrder(newItemPayload: AddItemToTable) {
    return this._httpClient.post<any>('api/add-request', newItemPayload);
  }
}
